import axios from '../utils/axios'

export function sendEvent(params){
    return axios.post('/land/clickEvent/', params)
}
